import { PlainButtonProps as Props } from './PlainButton';

export { default } from './PlainButton';
export type PlainButtonProps = Props;
